export default {
  init() {
    // Only the over-hero header needs this; every other page already has a
    // solid bar.
    const header = document.querySelector('.header--over-hero');

    if (!header) {
      return;
    }

    const headline = document.querySelector('.hero__headline');

    const update = () => {
      // The bar never returns to the opaque grey on this page: it is fully
      // transparent at the top and, from the moment the headline passes under
      // it, stays on the translucent blurred pane all the way down. That pane
      // is what keeps the white nav readable over the light sections below the
      // hero, which is the job `is-solid` used to do. The class is no longer
      // set anywhere; its CSS is left in place so the old behaviour can be
      // restored by re-adding this toggle alone.

      // Within the hero the bar stays fully transparent until the headline
      // scrolls up underneath it; from then on it needs the blurred pane.
      const reachedHeadline = headline
        ? headline.getBoundingClientRect().top <= header.offsetHeight
        : false;

      if (reachedHeadline) {
        header.classList.add('is-blurred');
        // Shrink at the same moment as the blur rather than waiting for the
        // 250px threshold in Mobile.js. This handler is registered after that
        // one, so the class sticks; Mobile.js still clears it near the top.
        header.classList.add('is-shrinked');
      } else {
        header.classList.remove('is-blurred');
      }
    };

    update();
    window.addEventListener('scroll', update);
    window.addEventListener('resize', update);
  }
};
